import { render } from "./ImagePagination.vue?vue&type=template&id=e06204ea&scoped=true"
import script from "./ImagePagination.vue?vue&type=script&lang=js"
export * from "./ImagePagination.vue?vue&type=script&lang=js"

import "./ImagePagination.vue?vue&type=style&index=0&id=e06204ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e06204ea"]])

export default __exports__